import { ActionConfig, ActionContext, IAction } from '../Action'

export class SubmitAction implements IAction {
    static Id = 'Submit' as const
    constructor(
        private actionContext: ActionContext,
        private config?: ActionConfig
    ) {
        this.addToWorkbench()
    }

    addToWorkbench(): void {
        this.actionContext.workbenchUiAccessor?.toolbar.addAction(
            {
                id: 'Submit',
                title: this.config?.title ?? 'Submit',
                type: 'button',
                onClick:
                    this.config?.onClick ??
                    (async () => {
                        const canSubmit = await this.actionContext.task.validateData()
                        if (!canSubmit) {
                            return
                        }
                        const errors =
                            this.actionContext.studio.inputManager.getViolationCount('error')
                        if (errors > 0) {
                            this.actionContext.studio.pluginManager.handleSubmissionViolation()
                            this.actionContext.modalManager?.showModal('violations-modal')
                            this.actionContext.task.ui?.updater.forceUpdate()
                            return
                        }
                        const config = this.actionContext.studio.taskConfig
                        this.actionContext.modalManager?.setModalMetaData('submit-modal', {
                            taskMode: config.mode,
                        })
                        this.actionContext.modalManager?.showModal('submit-modal')
                    }),
                color: 'primary',
                tooltip: this.config?.tooltip,
                disabled: this.config?.disabled ?? false,
            },
            this.config?.placement
        )
    }

    removeFromWorkbench(): void {
        this.actionContext.workbenchUiAccessor?.toolbar.removeAction('Submit')
    }
}
